import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import wolfpackLogo from "../../commom/Assets/images/LogoNew.png";
import phoneMockup from "../../commom/Assets/images/PhoneMockUp.png"

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const DownloadApp = () => {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                width: "100%",
                background: "black",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: { xs: "35px 20px 20px", md: "50px 40px 20px" },
                overflow: "hidden",
                position: "relative",
            }}
        >

            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background: "linear-gradient(to bottom, rgba(20,20,20,0.35) 0%, rgba(20,20,20,0.6) 100%)",
                    zIndex: 0,
                    pointerEvents: "none",
                }}
            />

            <Box
                sx={{
                    zIndex: 1,
                    width: "100%",
                    maxWidth: 460,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 3,
                        animation: `${fadeUp} 0.5s ease both`,
                    }}
                >
                    <Box
                        component="img"
                        src={wolfpackLogo}
                        alt="Wolfpack"
                        sx={{ height: 38, width: "auto" }}
                    />
                </Box>

                <Box sx={{ animation: `${fadeUp} 0.55s 0.05s ease both`, mb: 1 }}>
                    <Typography
                        sx={{
                            fontSize: { xs: "3rem", sm: "3.5rem" },
                            fontWeight: 900,
                            lineHeight: 1.05,
                            letterSpacing: "-1.5px",
                            background: `linear-gradient(90deg,
                                #FF6A00 0%,
                                #FF2D95 40%,
                                #7B2CFF 70%,
                                rgb(43, 12, 253) 100%)`,
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text",
                        }}
                    >
                        Invest Now,
                        <br />
                        Pay Later
                    </Typography>
                </Box>

                <Typography
                    sx={{
                        fontSize: { xs: "1.1rem", sm: "1.25rem" },
                        fontWeight: 700,
                        color: "white",
                        mb: 1.5,
                        animation: `${fadeUp} 0.58s 0.07s ease both`,
                    }}
                >
                    with Booster Loans
                </Typography>

                {/* Subtext */}
                <Typography
                    sx={{
                        fontSize: "0.90rem",
                        color: "#FFFFFF",
                        lineHeight: 1.75,
                        maxWidth: 340,
                        mb: 4,
                        animation: `${fadeUp} 0.6s 0.09s ease both`,
                    }}
                >
                    Access extra buying power instantly with our exclusive Booster Loans. The markets won't wait, now neither do you.
                </Typography>
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        mt: 1,
                        mb: -2,
                        overflow: "hidden",
                    }}
                >
                    <Box
                        component="img"
                        src={phoneMockup}
                        alt="Wolfpack app"
                        sx={{
                            width: {
                                xs: "95%",
                                sm: "90%",
                                md: "85%"
                            },
                            maxWidth: 380,
                            display: "block",
                            marginBottom: 0,
                            animation: `${fadeUp} 0.65s 0.1s ease both`,
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        animation: `${fadeUp} 0.7s 0.12s ease both`,
                    }}
                >
                    <Box
                        component="a"
                        href="https://play.google.com/store/apps/details?id=inc.financial.wolfpack"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                            px: 2.2,
                            py: 1.3,
                            flex: 1,
                            maxWidth: 195,
                            backdropFilter: "blur(6px)",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                            "&:hover": {
                                transform: "translateY(-3px)",
                                boxShadow: "0 12px 28px rgba(0,0,0,0.45)",
                            },
                        }}
                    >
                        <img
                            src={'https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/Group%202.png-7b4ff4d7-ae9a-4efa-b5e8-629ed9a0d4fa'}
                            alt="Get it on Google Play"
                            style={{ height: 50, width: "auto", display: "block", }}
                        />
                    </Box>

                    <Box
                        component="a"
                        href="https://apps.apple.com/in/app/wolfpack-financial/id1610870346"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                            px: 2.2,
                            py: 1.3,
                            textDecoration: "none",
                            flex: 1,
                            maxWidth: 195,
                            backdropFilter: "blur(6px)",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                            "&:hover": {
                                transform: "translateY(-3px)",
                                boxShadow: "0 12px 28px rgba(0,0,0,0.45)",
                            },
                        }}
                    >
                        <img
                            src={'https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/Group%201.png-06bccd93-27dc-42e6-bcb9-71c0272641cd'}
                            alt="Download on the App Store"
                            style={{ height: 50, width: "auto", display: "block" }}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default DownloadApp;